import React, { Component } from "react";
import Documents from "../../../components/Documents/Documents";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesForm
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class DocumentsForm extends Component {
    render() {
        return (
            <Documents />
        )
    }
}

export default DocumentsForm;